var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { UserPlusIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { useContext, useState } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { toast } from "react-toastify";
import { WPQTIconButton } from "../../../../components/common/Button/Button";
import { WPQTInput } from "../../../../components/common/Input/Input";
import { WPQTTextarea } from "../../../../components/common/TextArea/TextArea";
import { ADD_USER } from "../../../../constants";
import { useUserActions } from "../../../../hooks/actions/useUserActions";
import { UserContext } from "../../../../providers/UserContextProvider";
function AddUser() {
    const [showInput, setShowInput] = useState(false);
    const [userName, setUserName] = useState("");
    const [userDescription, setUserDescription] = useState("");
    const { userDispatch } = useContext(UserContext);
    const { createUser } = useUserActions();
    const onCreateUser = () => __awaiter(this, void 0, void 0, function* () {
        if (!userName) {
            toast.error("User name is required");
            return;
        }
        yield createUser(userName, userDescription, (userData) => {
            userDispatch({ type: ADD_USER, payload: userData });
            clearStatus();
        });
    });
    const clearStatus = () => {
        setUserName("");
        setUserDescription("");
        setShowInput(false);
    };
    return (_jsx("div", { className: "wpqt-mb-6", children: showInput ? (_jsxs("div", { className: "wpqt-w-1/4", children: [_jsx("label", { className: "wpqt-mb-2 wpqt-block wpqt-font-semibold", children: __("User name", "quicktasker") }), _jsx(WPQTInput, { value: userName, onChange: setUserName, className: "wpqt-w-full" }), _jsx("label", { className: "wpqt-mb-2 wpqt-block wpqt-font-semibold", children: __("User description", "quicktasker") }), _jsx(WPQTTextarea, { value: userDescription, onChange: setUserDescription, className: "wpqt-w-full" }), _jsxs("div", { className: "wpqt-flex wpqt-justify-end wpqt-gap-3", children: [_jsx(WPQTIconButton, { text: __("Cancel", "quicktasker"), onClick: clearStatus, icon: _jsx(XMarkIcon, { className: "wpqt-icon-red wpqt-size-5" }) }), _jsx(WPQTIconButton, { text: __("Add", "quicktasker"), onClick: onCreateUser, icon: _jsx(UserPlusIcon, { className: "wpqt-icon-green wpqt-size-5" }) })] })] })) : (_jsx(WPQTIconButton, { text: __("Add User", "quicktasker"), onClick: () => setShowInput(true), icon: _jsx(UserPlusIcon, { className: "wpqt-icon-green wpqt-size-5" }) })) }));
}
export { AddUser };
